import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'page',
            props: {
                ...segmentProps,
                source: '?@router.location.state.tracking.source',
                referrer: '?@history.previous',
            },
        },
    },
};
